import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';

export const PLANNING_CONSTANTS = {
	API: {
		DEFAULT_PAGE_SIZE: 20,
		DEFAULT_ORDER_DIRECTION: 'ASC' as const,
		SEARCH_DEBOUNCE_MS: 1500,
		DEBOUNCE_DELAY: 2000,
	},

	UI: {
		SCROLL_OFFSET: -140,
		MAIN_FILTER: {
			EXPANDED_WIDTH: 330,
			COLLAPSED_WIDTH: 60,
		},
	},

	DEFAULTS: {
		FILTERS: {
			customer: { logicalOperator: 'and' as const },
			commercial: { logicalOperator: 'and' as const },
			product: { logicalOperator: 'and' as const },
		},
	},

	MESSAGES: {
		ERRORS: {
			MISSING_PARAMETERS: 'Parâmetros obrigatórios ausentes',
			MISSING_CYCLE_ID: 'cycleId obrigatório',
			MISSING_FILTERS: 'Filtros não aplicados.',
		},
		SUCCESS: {
			PLAN_SAVED: 'Plano salvo com sucesso!',
			FINALIZATION_SUCCESS: 'Finalização realizada com sucesso!',
		},
	},
} as const;

export const PLANNING_BY_LEVEL_MESSAGES = {
	labels: {
		FINALIZE_COLLABORATION: 'Finalizar colaboração',
		FINALIZE_CONSENSUS: 'Finalizar consenso',
		ADJUST_APPORTIONMENT: 'Ajustar Rateio',
		CANCEL: 'Cancelar',
		SAVE: 'Salvar',
	},
	messages: {
		FINALIZE_TOOLTIP: (planningType: PlanningTypes): string =>
			`Adicionar valor 0 para os níveis de hierarquias sem preenchimento e finalizar ${
				planningType === 'collaboration' ? 'colaboração' : 'consenso'
			}`,
		IS_LOADING_SAVE_TOOLTIP:
			'O rateio está sendo aplicado para todos os itens. Assim que finalizar, o botão Salvar será liberado',
		ADJUST_APPORTIONMENT_TOOLTIP:
			'Alterar a base do rateio para itens filtrados.',
		CANCEL_TOOLTIP: 'Cancelar e voltar ao último valor salvo.',
	},
	errors: {
		REQUIRED_FILTERS_TITLE: 'Filtros obrigatórios',
		REQUIRED_FILTERS_DESCRIPTION:
			'Aplique os filtros de Produto, Comercial e Cliente antes de finalizar.',
	},
} as const;

export const MONTH_MAPPING: Record<string, string> = {
	'01': 'JAN',
	'02': 'FEV',
	'03': 'MAR',
	'04': 'ABR',
	'05': 'MAI',
	'06': 'JUN',
	'07': 'JUL',
	'08': 'AGO',
	'09': 'SET',
	'10': 'OUT',
	'11': 'NOV',
	'12': 'DEZ',
} as const;
